import component from '@/mixins/component'

export default {
  name: 'kpi',
  mixins: [component],
  props: {
    data: {},
    awards: {}
  }
}
